interface Step {
  image: string;
  title: string;
  description: string;
}

interface ModalStepsFGTSProps {
  open: boolean;
  steps: Step[];
  currentStep: number;
  onNext: () => void;
  onPrev: () => void;
  onClose: () => void;
}

const ModalStepsFGTS = ({
  open,
  steps,
  currentStep,
  onNext,
  onPrev,
}: ModalStepsFGTSProps) => {
  if (!open) return null;
  const step = steps[currentStep];

  const formatDescription = (text: string) => {
    const parts = text.split(/"([^"]*)"/);
    return parts.map((part, index) => {
      if (index % 2 === 1) {
        return (
          <span key={index} className="font-semibold">
            {`"${part}"`}
          </span>
        );
      }
      return part;
    });
  };
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black01/40">
      <div className="relative mx-2 flex w-full max-w-md flex-col items-center rounded-2xl bg-white01 p-5 shadow-xl">
        <div className="w-full">
          <img
            src={step.image}
            alt={step.title}
            className="w-full rounded-2xl object-cover"
          />
        </div>
        <div className="flex w-full flex-col items-center pt-4">
          <div className="mb-4 flex w-full items-center justify-center gap-2">
            {steps.map((_, idx) => (
              <div
                key={idx}
                className={`h-2 flex-1 rounded-full ${idx <= currentStep ? "bg-primary" : "bg-gray01"}`}
              />
            ))}
          </div>
          <h3 className="mb-2 w-full text-left text-lg font-semibold text-black01 sm:text-xl">
            {step.title}
          </h3>
          <p className="mb-5 w-full text-left text-sm font-medium text-black01 sm:text-base">
            {formatDescription(step.description)}
          </p>
          <div className="flex w-full gap-2 border-t border-gray02 pt-4">
            <button
              className="flex-1 rounded-full bg-gray01 py-3 text-base font-bold text-black02 disabled:opacity-60"
              onClick={onPrev}
              disabled={currentStep === 0}
            >
              Voltar
            </button>
            <button
              className="flex-1 rounded-full bg-primary py-3 text-base font-bold text-white01 hover:bg-primary hover:brightness-110 disabled:opacity-60"
              onClick={onNext}
            >
              {currentStep === 7 ? "Tentar novamente" : "Avançar"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalStepsFGTS;
